module.exports = "/_next/static/images/7960ddf6d373cdc6123bf8df4963887e-challenge-the-system-lg@2x.jpg.webp";